module.exports = __webpack_public_path__ + "img/0-5.d97fe6f3.png";